import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { BpCoreModule } from '../../../../../../bp-core/src/lib/bp-core.module';
import { MatRippleModule } from '@angular/material/core';

@Component({
    selector: 'app-image-info-card',
    templateUrl: './image-info-card.component.html',
    styleUrls: ['./image-info-card.component.scss'],
    standalone: true,
    imports: [
        MatRippleModule,
        BpCoreModule,
        NgClass,
    ],
})
export class ImageInfoCardComponent {
  @Input() imageUrl: string;
  @Input() imageFullRounded: boolean;
  @Input() alt: string;
  @Input() addRipple: boolean = false;
}
